import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {baseStyles, BORDER_RADIUS, FIELD_SPACE, withMediaQueries, withMultipleStyles} from "src/styles/Styles";
import Space from "../commons/Space";
import {Button, ButtonBase, GridList, IconButton, Tooltip} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import AddIcon from '@material-ui/icons/Add';
import {ColorSubTitle, ColorWhite} from "src/styles/Colors";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import ValueHelper, {getInitialFiles} from "../../utils/ValueHelper";
import {map} from "lodash";
import FormSectionHeaderView from "../commons/FormSectionHeaderView";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import Typography from "@material-ui/core/Typography";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import TextView from "../commons/TextView";
import {FontWeightMedium, FontWeightRegular} from "src/res/FontWeight";
import FieldSpace from "src/js/components/commons/FieldSpace";
import {ImageIcon} from "src/js/components/commons/ViewHelper";
import AppIcon, {IconArrowDownLong, IconArrowUpLong} from "src/js/components/commons/AppIcon";
import constants from "src/js/constants";
import SingleFilePicker, {ACCEPTED_IMAGE_MIMES, FILE_TYPE_IMAGE} from "src/js/components/commons/SingleFilePicker";
import {IMAGE_MAX_SIZE, IMAGE_MAX_WIDTH_HEIGHT} from "src/js/components/commons/FilePicker";
import SectionHeaderView from "src/js/components/commons/SectionHeaderView";
import FileHelper from "src/js/utils/FileHelper";

const useStyles = () => ({
  optionsWrapper: {
    display: 'flex',
    width: '100%',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  optionCard: {
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    backgroundColor: ColorWhite,
    padding: 8,
    margin: 4,
    minHeight: 126,
    border: `1px solid rgba(0,0,0,0.05)`
  },
});

const MAX_QUESTIONS_COUNT = 100;
const MAX_OPTIONS_COUNT = 4;

class ManageActivityQuestions extends React.Component {

  constructor(props) {
    super(props);
    const {activityData} = this.props;

    // this.isQuestionReset = false;
    // if (activityData.type === constants.activity.types.QUESTIONNAIRE) {
    //   if (activityData.questions && activityData.questions.length > 0 && activityData.questions[0].id < 0) {
    //     activityData.questions = null;
    //     this.isQuestionReset = true;
    //   }
    // }

    let questionNo = 1;
    const questions = [];
    if (activityData.questions) {
      activityData.questions.forEach((question) => {
        const options = [];
        const rightOptions = [];
        let rightOption = '';
        let optionNo = 1;
        question.options.forEach((qOption) => {
          options.push({
            optionNo: optionNo,
            id: qOption.id,
            name: qOption.name,
            nameAr: qOption.nameAr || '',
            isRight: qOption.isRight,
          });
          if (qOption.name && qOption.name.trim().length > 0) {
            rightOptions.push(qOption.name);
          }
          if (qOption.isRight) {
            rightOption = qOption.name;
          }
          optionNo++;
        });
        if (options.length < MAX_OPTIONS_COUNT) {
          for (let i = options.length; i < MAX_OPTIONS_COUNT; i++) {
            options.push({
              id: -question * 10 + (i+1),
              optionNo: (i+1),
              name: '',
              nameAr: '',
              isRight: 0,
            });
          }
        }

        questions.push({
          questionNo: questionNo,
          id: question.id,
          name: question.name,
          nameAr: question.nameAr || '',
          options: options,
          rightOptions: rightOptions,
          rightOption: rightOption,
          section: {id: questionNo, label: <FormattedMessage id={'activity.hashQWithNumberNName'} values={{value: questionNo, value2: question.name}}/>, expand: true},
        });
        questionNo++;
      });
    } else {
      questions.push(this.getNewQuestion(questionNo));
    }

    this.state = {
      qTitle: activityData.qTitle || '',
      imageUrl2: activityData.imageUrl2,
      imageFiles2: activityData.imageFiles2,
      isImageDeleted2: activityData.isImageDeleted2,
      questions: questions,
      winnersByValue: activityData.winnersByValue,
      deleteQuestionIds: activityData.deleteQuestionIds || [],
      showValidationMsg: false,
    };

    this.initialFiles2 = getInitialFiles(activityData.imageFiles2, activityData.imageUrl2, FILE_TYPE_IMAGE);
    this.sectionRightAnswerCount = {id: -1, labelId: 'activity.correctAnswersCount', subLabelId: 'activity.correctAnswersCountHint', expand: true, expandAlways: true};
  }

  componentDidMount() {
    this.props.moveNextCallback(this);
    if (this.isQuestionReset) {
      this.props.onDataUpdated(this.getData(true));
    }
  }

  componentWillUnmount() {
    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);
      this.timeoutHandler = null;
    }
  }

  updateState(fields) {
    this.setState(fields, () => {
      if (this.timeoutHandler) {
        clearTimeout(this.timeoutHandler);
        this.timeoutHandler = null;
      }
      this.timeoutHandler = setTimeout(() => {
        this.props.onDataUpdated(this.getData(true));
        this.timeoutHandler = null;
      }, 400);
    });
  }

  reloadView() {
    this.updateState({reload: !this.state.reload, showValidationMsg: false});
  }

  getData(excludeError, showButtonError = false) {
    const {activityData} = this.props;
    const {
      qTitle,
      imageUrl2,
      imageFiles2,
      isImageDeleted2,
      questions,
      winnersByValue,
      deleteQuestionIds
    } = this.state;

    if (!excludeError) {
      if (this.isQuestionTitleIncorrect(qTitle)
        || !this.areQuestionsCorrect(true)) {
        this.setState({showValidationMsg: true, showButtonError});
        return false;
      }
    }
    const questionsL = [];
    const questionIds = [];
    questions.forEach((question) => {
      let isRightChecked = false;
      const options = [];
      question.options.forEach((qOption) => {
        if (qOption.name && qOption.name.trim().length > 0) {
          // const qOptionL = cloneDeep(qOption);
          const qOptionL = {...qOption};
          if (!isRightChecked && question.rightOption === qOptionL.name) {
            qOptionL.isRight = 1;
            isRightChecked = true;
          } else {
            qOptionL.isRight = 0;
          }
          options.push(qOptionL);
        }
      });
      if (activityData.correction) {
        question.rightOptionHint = this.context.intl.formatMessage({id: 'activity.questionnaireCorrectAnswerPrompt'});
      } else {
        question.rightOptionHint = null;
      }
      // const questionL = cloneDeep(question);
      const questionL = {...question};
      questionL.options = options;
      questionL.qOptions = options;
      delete questionL.section;
      delete questionL.rightOptions;
      delete questionL.rightOption;

      questionsL.push(questionL);
      questionIds.push(''+ questionL.id);
    });

    return {
      qTitle,
      imageUrl2,
      imageFiles2,
      isImageDeleted2,
      questions: questionsL,
      questionIds: questionIds,
      // winnersBy: 1,
      // winnersByValue,
      deleteQuestionIds
    };
  }

  render() {
    const {
      showValidationMsg,
      showButtonError,
      winnersByValue,
      qTitle,
      questions,
    } = this.state;
    const {activityData, classes, isXS} = this.props;

    return (
      <div className={classes.formActivityWide}>
        <SectionHeaderView labelId={activityData.type === constants.activity.types.SURVEY ? 'activity.describeSurvey' : 'activity.describeQuiz'}/>
        <div className={classes.viewRowFullWidthNoCenter}>
          <React.Fragment>
            <SingleFilePicker
              key={'SFP1'}
              required={false}
              hideDropzoneText={true}
              size={'xsmall'}
              filesLimit={1}
              showPreviewsInDropzone={true}
              acceptedFiles={ACCEPTED_IMAGE_MIMES}
              maxFileSize={IMAGE_MAX_SIZE}
              maxWidthOrHeight={IMAGE_MAX_WIDTH_HEIGHT}
              aspectRatio={16/9}
              initialFiles={this.initialFiles2}
              onChange={(files) => {
                this.onChangeFiles(files, 'imageUrl2');
              }}
              onDelete={(file) => {
                this.onDeleteFile(file, 'imageUrl2');
              }}
            />
            <FieldSpace vertical={true} multiplier={0.8}/>
          </React.Fragment>

          <TextField
            variant="filled"
            required
            fullWidth
            multiline
            rows={isXS ? 1 : 1.38}
            rowsMax={8}
            size="small"
            type="text"
            id="qTitle"
            name="qTitle"
            label={<FormattedMessage id={activityData.type === constants.activity.types.SURVEY ? 'activity.surveyPrompt' : 'activity.quizPrompt'} />}
            InputProps={{disableUnderline: true}}
            inputProps={{maxLength: 200}}
            value={qTitle}
            onChange={this.onChange}
            error={showValidationMsg && this.isQuestionTitleIncorrect(qTitle)}
            helperText={showValidationMsg && this.isQuestionTitleIncorrect(qTitle) && <FormattedMessage id='generic.validation.required' />}
          />
        </div>
        <FieldSpace multiplier={2} />

        {questions.map((question, index) => this.getViewForQuestion(question, index))}

        {questions.length < MAX_QUESTIONS_COUNT ?
          <React.Fragment>
            <div>
              <Button
                size={isXS ? 'medium' : 'large'}
                variant={"outlined"}
                color="primary"
                startIcon={<AddIcon />}
                onClick={this.onAddNewQuestionClicked}>
                {<FormattedMessage id={'activity.addAnotherQuestion'} />}
              </Button>
            </div>
            {showValidationMsg && showButtonError && !this.areQuestionsCorrect() && <FormHelperText className={classes.helperError}><FormattedMessage id='activity.correctErrorAbove' /></FormHelperText>}
          </React.Fragment>
          : null
        }
        <FieldSpace />

        {/*<div className={classes.formActivity} style={{marginTop: .5 * FIELD_SPACE, padding: 0}}>*/}
        {/*  {this.getFormSectionHeaderView(this.sectionRightAnswerCount)}*/}
        {/*  <div className={classes.viewColumnFullWidth} style={{padding: 16}}>*/}
        {/*    <TextField*/}
        {/*      variant="filled"*/}
        {/*      required*/}
        {/*      fullWidth*/}
        {/*      size="small"*/}
        {/*      type="number"*/}
        {/*      id="winnersByValue"*/}
        {/*      name="winnersByValue"*/}
        {/*      label={<FormattedMessage id={'activity.minCorrectAnswersCount'} />}*/}
        {/*      value={winnersByValue}*/}
        {/*      InputProps={{disableUnderline: true}}*/}
        {/*      inputProps={{min: 0, max: questions.length}}*/}
        {/*      onChange={this.onChange}*/}
        {/*      onKeyDown={textFieldIntegerOnKeyDown}*/}
        {/*      error={showValidationMsg && !showButtonError && !winnersByValue && winnersByValue !== 0}*/}
        {/*      helperText={showValidationMsg && !showButtonError && !winnersByValue && winnersByValue !== 0 ? <FormattedMessage id={'generic.validation.required'} /> : null}*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*</div>*/}
      </div>
    )
  }

  getFormSectionHeaderView(section) {
    const {classes} = this.props;
    return (
      <FormSectionHeaderView classes={classes} section={section} />
    );
  }

  getViewForQuestion(question, questionIndex) {
    const {activityData, classes, isXS} = this.props;
    const {showValidationMsg} = this.state;
    const disableRightOptionSelector = !question.rightOptions || question.rightOptions.length === 0;
    // const isOptionIncorrect = showValidationMsg && question.options[0] && (!question.options[0].name || question.options[0].name.trim().length === 0);
    const isQuestionNameIncorrect = !question.name || question.name.trim().length === 0;
    const fieldSpace = isXS ? 16 : FIELD_SPACE;
    return (
      <div key={''+ question.questionNo} className={classes.viewColumnFullWidthNoCenter1}>
        {this.getSectionHeaderView(question, questionIndex)}
        {question.section.expand ?
          <React.Fragment>
            <TextField
              variant="filled"
              required
              fullWidth
              multiline
              rows={isXS ? 1 : 1.4}
              rowsMax={8}
              size="small"
              type="text"
              id={"name"+ questionIndex}
              name={"name"}
              label={<FormattedMessage id={'activity.question'} />}
              InputProps={{disableUnderline: true}}
              inputProps={{maxLength: 500}}
              value={question.name}
              onChange={this.onChangeQuestion.bind(this, questionIndex)}
              error={showValidationMsg && isQuestionNameIncorrect}
              helperText={showValidationMsg && isQuestionNameIncorrect && <FormattedMessage id='generic.validation.required' />}
            />
            <FieldSpace />

            <div style={{margin: isXS ? -6 : -8}}>
              <GridList spacing={0} cols={isXS ? 2 : 2} className={classes.optionsWrapper} cellHeight={'auto'}>
                {question.options.map((option, optionIndex) => this.getViewForQuestionOption(question, questionIndex, option, optionIndex))}
              </GridList>
              <FormHelperText className={classes.helper} style={{marginTop: -2, marginBottom: 2}}><FormattedMessage id='activity.hintQuestionOptions' /></FormHelperText>
            </div>
            <FieldSpace />

            {activityData.type === constants.activity.types.QUESTIONNAIRE ?
              <FormControl
                fullWidth
                required
                variant="filled"
                size="small"
                error={showValidationMsg && !question.rightOption}>
                <InputLabel id="selectLabelId" disabled={disableRightOptionSelector}>{<FormattedMessage id='activity.selectRightOption'/>}</InputLabel>
                <Select
                  style={{maxWidth: window.appWidth - 32}}
                  disabled={disableRightOptionSelector}
                  disableUnderline={true}
                  labelId="selectLabelId"
                  id={"rightOption"+ questionIndex}
                  name="rightOption"
                  value={question.rightOption}
                  onChange={this.onChangeRightOption.bind(this, questionIndex)}>
                  {map(question.rightOptions, (item) => {
                    return <MenuItem key={item} value={item}>{item}</MenuItem>
                  })}
                </Select>
              </FormControl>
              : null
            }
          </React.Fragment>
          : null
        }
        <FieldSpace multiplier={2}/>
      </div>
    );
  }

  getViewForQuestionOption(question, questionIndex, option, optionIndex) {
    const {classes, isXS} = this.props;
    const {showValidationMsg} = this.state;
    const optionNumber = optionIndex + 1;
    const isRequired = optionIndex <= 1;
    const isOptionIncorrect = showValidationMsg && isRequired && (!option.name || option.name.trim().length === 0);
    let isOptionAlreadyPresent = false;
    if (!isOptionIncorrect) {
      isOptionAlreadyPresent = option.isDuplicate;
    }
    let disabled = false;
    let prevOption = null;
    if (optionIndex > 0) {
      prevOption = question.options[optionIndex - 1];
      disabled = !prevOption.name || prevOption.name.trim().length === 0;
    }
    return (
      <div className={classes.viewColumn} style={{padding: isXS ? 6 : 8}}>
        <div className={classes.flexRowNoCenter}>
          <div className={classes.flex1}>
            <TextField
              disabled={disabled && !isRequired}
              variant="filled"
              required={isRequired}
              fullWidth
              size="small"
              type="text"
              id={"name"+ optionIndex}
              name="name"
              label={<FormattedMessage id={'activity.manage.questionOption'} values={{value: optionNumber}} />}
              InputProps={{disableUnderline: true}}
              inputProps={{maxLength: 200}}
              value={option.name}
              onChange={this.onChangeOption.bind(this, questionIndex, optionIndex)}
              error={isOptionIncorrect || isOptionAlreadyPresent}
              helperText={isOptionIncorrect ? <FormattedMessage id='activity.optionRequired' /> : isOptionAlreadyPresent ? <FormattedMessage id='activity.optionAlreadyPresent' /> : null}
            />
          </div>
        </div>
      </div>
    );
  }

  getSectionHeaderView(question, questionIndex) {
    const {classes, isXS} = this.props;
    const {questions} = this.state;
    const section = question.section;
    let isNotExpended = false;
    if (section.expand) {
      section.label = <FormattedMessage id={'activity.hashQWithNumber'} values={{value: question.questionNo}}/>
    } else {
      isNotExpended = true;
      section.label = <FormattedMessage id={'activity.hashQWithNumberNName'} values={{value: question.questionNo, value2: question.name}}/>
    }
    return (
      <div className={classes.viewColumnFullWidthNoCenter1}>
        <div className={classes.expandCollapseBar}>
          <ButtonBase disabled={true} className={classes.buttonBaseApp} onClick={this.onFormSectionToggle.bind(this, question)}>
            <div className={classes.flexRow}>
              <div className={classes.viewColumnFullWidthNoCenter}>
                <div className={classes.flexRow}>
                  <TextView numberOfLines={2} variant={isNotExpended ? 'body2' : 'subtitle1'} color={'primary'} align={'left'} fontWeight={isNotExpended ? FontWeightRegular : FontWeightMedium}>
                    {section.labelId ?
                      <FormattedMessage id={section.labelId} />
                      : section.label
                    }
                  </TextView>
                </div>
                {section.subLabelId ?
                  <Typography color={'textSecondary'} variant={'caption'} align={'left'} style={{marginTop: -10, marginBottom: 8}}>
                    <FormattedMessage id={section.subLabelId} />
                  </Typography>
                  : null
                }
              </div>
              <Space vertical={16} />
            </div>
          </ButtonBase>
          <Tooltip title={<FormattedMessage id={section.expand ? 'activity.collapseQuestion' : 'activity.expandQuestion'} />} style={{width: 44, height: 44}}>
            <IconButton size={'small'} onClick={this.onFormSectionToggle.bind(this, question)}>
              {section.expand ? <RemoveCircleOutlineIcon color={ColorSubTitle} /> : <AddCircleOutlineIcon color={ColorSubTitle} />}
            </IconButton>
          </Tooltip>
          <Tooltip title={<FormattedMessage id={'activity.moveUpQuestion'} />}>
            <IconButton disabled={questionIndex === 0} size={'small'} onClick={this.onMoveUpSection.bind(this, question, questionIndex)} style={{width: 44, height: 44}}>
              {<AppIcon icon={IconArrowUpLong} color={ColorSubTitle} style={{width: 18, height: 18, opacity: questionIndex === 0 ? 0.5 : 1}} />}
            </IconButton>
          </Tooltip>
          <Tooltip title={<FormattedMessage id={'activity.moveDownQuestion'} />}>
            <IconButton disabled={questionIndex === questions.length - 1} size={'small'} onClick={this.onMoveDownSection.bind(this, question, questionIndex)} style={{width: 44, height: 44}}>
              {<AppIcon icon={IconArrowDownLong} color={ColorSubTitle} style={{width: 18, height: 18, opacity: questionIndex === questions.length - 1 ? 0.5 : 1}} />}
            </IconButton>
          </Tooltip>
          <Tooltip title={<FormattedMessage id={'activity.removeQuestion'} />}>
            <IconButton size={'small'} onClick={this.onDeleteSection.bind(this, question, questionIndex)} className={classes.imageIconButton}>
              {<ImageIcon src={require('src/images/ic_delete_bg.png')} width={38} height={38} />}
            </IconButton>
          </Tooltip>
        </div>
      </div>
    );
  }

  onFormSectionToggle = (question) => {
    const {questions} = this.state;
    question.section.expand = !question.section.expand;
    this.setState({questions: questions});
  }

  onDeleteSection = (question, questionIndex) => {
    let {questions, deleteQuestionIds, winnersByValue} = this.state;
    if (question.id) {
      deleteQuestionIds.push(question.id);
    }
    questions.splice(questionIndex, 1);
    if (questions.length === 0) {
      questions.push(this.getNewQuestion(1));
    }
    winnersByValue = Math.min(winnersByValue, questions.length)

    // reset question no
    let questionNo = 1;
    questions.forEach((question) => {
      question.questionNo = questionNo;
      question.section.id = questionNo;
      questionNo++;
    });
    this.updateState({questions, deleteQuestionIds, winnersByValue});
  }

  onMoveUpSection = (question, questionIndex) => {
    const {questions} = this.state;
    if (questionIndex > 0) {
      const prevQuestion = questions[questionIndex - 1];
      const questionNo = question.questionNo;
      const sectionId = question.section.id;
      question.questionNo = prevQuestion.questionNo;
      question.section.id = prevQuestion.section.id;
      prevQuestion.questionNo = questionNo;
      prevQuestion.section.id = sectionId;

      questions[questionIndex - 1] = question;
      questions[questionIndex] = prevQuestion;
    }
    this.updateState({questions: questions});
  }

  onMoveDownSection = (question, questionIndex) => {
    const {questions} = this.state;
    if (questionIndex < questions.length - 1) {
      const nextQuestion = questions[questionIndex + 1];
      const questionNo = question.questionNo;
      const sectionId = question.section.id;
      question.questionNo = nextQuestion.questionNo;
      question.section.id = nextQuestion.section.id;
      nextQuestion.questionNo = questionNo;
      nextQuestion.section.id = sectionId;

      questions[questionIndex + 1] = question;
      questions[questionIndex] = nextQuestion;
    }
    this.updateState({questions: questions});
  }

  getNewQuestion(questionNo) {
    const questionId = questionNo - 1;
    const options = [];
    for (let i = 0; i < MAX_OPTIONS_COUNT; i++) {
      options.push({
        id: -questionId * 10 + (i+1),
        optionNo: (i+1),
        name: '',
        nameAr: '',
        isRight: 0,
      });
    }
    return {
      id: -questionId,
      questionNo: questionNo,
      name: '',
      nameAr: '',
      options: options,
      rightOptions: [],
      rightOption: '',
      section: {id: questionNo, label: <FormattedMessage id={'activity.hashQWithNumber'} values={{value: questionNo}}/>, expand: true},
    };
  }

  onAddNewQuestionClicked = () => {
    const data = this.getData(false, true);
    if (data) {
      const {questions} = this.state;
      questions.push(this.getNewQuestion(questions.length + 1));
      this.updateState({questions});
    }
  };

  isQuestionTitleIncorrect(qTitle) {
    const {activityData} = this.props;
    return (!qTitle || qTitle.trim().length === 0);
  }

  areQuestionsCorrect(expandQuestionOnError = false) {
    const {questions} = this.state;
    if (!questions || questions.length === 0) {
      return false;
    }
    let isCorrect = true;
    questions.forEach((question) => {
      if (!this.isQuestionCorrect(question, expandQuestionOnError)) {
        isCorrect = false;
      }
    });
    return isCorrect;
  }

  isQuestionCorrect(question, expandQuestionOnError) {
    let isCorrect = true;
    if (!question.name || question.name.trim().length === 0) {
      isCorrect = false;
    } else if (!question.options || question.options.length === 0) {
      isCorrect = false;
    } else if (!question.rightOption && this.props.activityData.type === constants.activity.types.QUESTIONNAIRE) {
      isCorrect = false;
    } else {
      let optionsName = [];
      for (let i = 0; i < question.options.length; i++) {
        const option = question.options[i];
        if (i < 2) {
          if (!option || !option.name || option.name.trim().length === 0) {
            isCorrect = false;
            break;
          }
        }
        if (option.name && option.name.trim().length > 0) {
          option.isDuplicate = false;
          if (optionsName.includes(option.name)) {
            option.isDuplicate = true;
            isCorrect = false;
          }
          optionsName.push(option.name);
        }
      }
    }
    if (expandQuestionOnError && !isCorrect) {
      question.section.expand = true;
    }
    return isCorrect;
  }

  onChangeFiles(files, id) {
    const {
      imageUrl1,
      imageUrl2,
      bgAudioUrl
    } = this.state;

    let eFileUrl = null;
    let keyFileUrl = null;
    let keyFiles = null;
    let keyFileObjs = null;
    if (id === 'imageUrl1') {
      eFileUrl = imageUrl1;
      keyFileUrl = 'imageUrl1';
      keyFiles = 'imageFiles1';
      keyFileObjs = 'fileObjsImage1';
    } else if (id === 'imageUrl2') {
      eFileUrl = imageUrl2;
      keyFileUrl = 'imageUrl2';
      keyFiles = 'imageFiles2';
      keyFileObjs = 'fileObjsImage2';
    } else if (id === 'bgAudioUrl') {
      eFileUrl = bgAudioUrl;
      keyFileUrl = 'bgAudioUrl';
      keyFiles = 'bgAudioFiles';
    }

    let lFiles = null;
    let lFileUrl = null;
    if (files && files.length > 0) {
      files.forEach((file) => {
        if (FileHelper.isFileNameSame(file, eFileUrl)) {
          lFileUrl = eFileUrl;
        } else {
          if (!lFiles) {
            lFiles = [];
          }
          lFiles.push(file);
        }
      });
    }

    this.updateState({showValidationMsg: false, [keyFileUrl]: lFileUrl, [keyFiles]: lFiles});
  }

  onDeleteFile(file, id) {
    const {
      imageUrl1,
      imageFiles1,
      fileObjsImage1,
      imageUrl2,
      imageFiles2,
      fileObjsImage2,
      bgAudioUrl,
      bgAudioFiles,
    } = this.state;

    let eFileUrl = null;
    let eFiles = null;
    let eFileObjs = null;
    let keyFileUrl = null;
    let keyFiles = null;
    let keyFileObjs = null;
    let keyIsFileDeleted = null;
    if (id === 'imageUrl1') {
      eFileUrl = imageUrl1;
      eFiles = imageFiles1;
      eFileObjs = fileObjsImage1;
      keyFileUrl = 'imageUrl1';
      keyFiles = 'imageFiles1';
      keyFileObjs = 'fileObjsImage1';
      keyIsFileDeleted = 'isImageDeleted1';
    } else if (id === 'imageUrl2') {
      eFileUrl = imageUrl2;
      eFiles = imageFiles2;
      eFileObjs = fileObjsImage2;
      keyFileUrl = 'imageUrl2';
      keyFiles = 'imageFiles2';
      keyFileObjs = 'fileObjsImage2';
      keyIsFileDeleted = 'isImageDeleted2';
    } else if (id === 'bgAudioUrl') {
      eFileUrl = bgAudioUrl;
      eFiles = bgAudioFiles;
      keyFileUrl = 'bgAudioUrl';
      keyFiles = 'bgAudioFiles';
      keyIsFileDeleted = 'isBgAudioDeleted';
    }

    let lFiles = [];
    let lFileUrl = eFileUrl;
    if (eFiles) {
      let index = 0;
      eFiles.forEach(lFile => {
        if (FileHelper.areFilesSame(lFile, file)) {
          lFiles.push(lFile);
        }
        index++;
      });
      lFiles = eFiles.filter(x => !lFiles.includes(x));
    }
    if (FileHelper.isFileNameSame(file, eFileUrl)) {
      lFileUrl = null;
    }

    this.updateState({showValidationMsg: false, [keyFileUrl]: lFileUrl, [keyFiles]: lFiles, [keyIsFileDeleted]: true});
  }

  onChange = (event) => {
    const {questions} = this.state;
    let value = event.target.value;
    if (event.target.name === 'winnersByValue') {
      const maxValue = questions.length;
      value = ValueHelper.getDecimalValue(value);
      if (ValueHelper.getEnglishValue(value) < 0) {
        value = 0;
      } else if (ValueHelper.getEnglishValue(value) > maxValue) {
        value = maxValue;
      }
    } else if (event.target.name === 'qTitle') {
      value = value.replace("\n", " ");
    }
    this.updateState({[event.target.name]: value, showValidationMsg: false});
  };

  onChangeQuestion = (questionIndex, event) => {
    const {questions} = this.state;
    let value = event.target.value;
    if (event.target.name === 'name') {
      value = value.replace("\n", " ");
    }
    questions[questionIndex][event.target.name] = value;
    this.updateState({questions: questions, showValidationMsg: false});
  };

  onChangeOption = (questionIndex, optionIndex, event) => {
    const {questions} = this.state;
    const question = questions[questionIndex];
    question.options[optionIndex][event.target.name] = event.target.value;
    question.rightOptions = [];
    question.options.forEach((qOption) => {
      if (qOption.name && qOption.name.trim().length > 0) {
        question.rightOptions.push(qOption.name);
      }
    });
    if (!question.rightOptions.includes(question.rightOption)) {
      question.rightOption = null;
    }
    this.updateState({questions: questions, showValidationMsg: false});
  };

  onChangeRightOption = (questionIndex, event) => {
    const {questions} = this.state;
    questions[questionIndex].rightOption = event.target.value;
    this.updateState({questions: questions, showValidationMsg: false});
  };

}

ManageActivityQuestions.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  app: PropTypes.object,
  activities: PropTypes.object,
  activityData: PropTypes.object,
  moveNextCallback: PropTypes.func.isRequired,
  onDataUpdated: PropTypes.func.isRequired,
};

ManageActivityQuestions.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
    activities: state.admin.activities,
  };
}

const mapDispatchToProps = () => {
  return {
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
    ['isMD', theme => theme.breakpoints.down('md'), {defaultMatches: true}]
  ])(ManageActivityQuestions))
);
